import rectangle from './rectangle';
import lshape from './lshape';
import ushape from './ushape';
import * as util from './util';

export { util };
export default {
  rectangle,
  lshape,
  ushape,
};

// Defined the order of shapes in picker
export const shapeOrder = ['rectangle', 'lshape', 'ushape'];
